/* An optional Contact signature: no native theme setting can follow a pointer path.
   The Shopify form and its submission remain entirely native. */
(() => {
  const key = Symbol.for('k9.contact.pawTrail');
  if (window[key]) {
    window[key].init();
    return;
  }
  const mouse = matchMedia('(hover: hover) and (pointer: fine)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const protectedContent = 'form, aside, a, button, input, textarea, label, h1, h2, h3, p, .rte, .multicolumn-card, details, figure, .k9-contact__intro, [role="dialog"]';
  const shape = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="5.6" cy="8.6" r="2.6"/><circle cx="9.8" cy="4.6" r="2.7"/><circle cx="14.6" cy="4.6" r="2.7"/><circle cx="18.8" cy="8.6" r="2.6"/><path d="M12.2 10.2c-3.9 0-6.9 3.2-6.9 6 0 2.1 1.6 3.6 3.6 3.6 1.3 0 2.1-.6 3.3-.6s2 .6 3.3.6c2 0 3.6-1.5 3.6-3.6 0-2.8-3-6-6.9-6Z"/></svg>';
  let teardown;

  function init() {
    if (teardown) teardown();
    const anchor = document.querySelector('[data-k9-paw-trail]');
    const main = anchor?.closest('main');
    if (!main) return;
    const layer = document.createElement('div');
    layer.className = 'k9-contact__paw-layer';
    layer.setAttribute('aria-hidden', 'true');
    main.prepend(layer);
    let last = null;
    let pending = null;
    let frame = 0;
    let sequence = 0;
    let lastTime = -Infinity;
    const clear = () => {
      cancelAnimationFrame(frame);
      frame = 0;
      pending = last = null;
      layer.replaceChildren();
    };
    const active = () => mouse.matches && !reduced.matches && !document.hidden;
    const draw = () => {
      frame = 0;
      const point = pending;
      pending = null;
      if (!point || !active() || !main.isConnected) return;
      const time = performance.now();
      if (time - lastTime < 90) return;
      const bounds = main.getBoundingClientRect();
      const x = point.x - bounds.left;
      const y = point.y - bounds.top;
      const distance = last ? Math.hypot(x - last.x, y - last.y) : Infinity;
      if (distance < 56) return;
      const direction = last ? Math.atan2(y - last.y, x - last.x) : -Math.PI / 2;
      const side = ++sequence % 2 ? 1 : -1;
      const px = x - Math.sin(direction) * 8 * side;
      const py = y + Math.cos(direction) * 8 * side;
      // Keep the entire mark within the page's empty margin, including its rotation.
      if (px < 18 || px > bounds.width - 18 || py < 18 || py > bounds.height - 18) return;
      const footprint = [[0, 0], [-18, -18], [18, -18], [-18, 18], [18, 18]];
      const touchesContent = footprint.some(([dx, dy]) => {
        const beneath = document.elementFromPoint(point.x + dx, point.y + dy);
        return !beneath || !main.contains(beneath) || beneath.closest(protectedContent);
      });
      if (touchesContent) {
        last = null;
        return;
      }
      const paw = document.createElement('span');
      paw.className = `k9-contact__paw${side < 0 ? ' k9-contact__paw--orange' : ''}`;
      paw.style.transform = `translate3d(${px - 12}px, ${py - 12}px, 0) rotate(${direction * 180 / Math.PI + 90}deg)`;
      paw.innerHTML = shape;
      paw.addEventListener('animationend', () => paw.remove(), { once: true });
      if (layer.childElementCount >= 14) layer.firstElementChild.remove();
      layer.append(paw);
      last = { x, y };
      lastTime = time;
    };
    const move = event => {
      if (!active() || event.pointerType !== 'mouse' || event.target.closest(protectedContent)) {
        pending = last = null;
        return;
      }
      pending = { x: event.clientX, y: event.clientY };
      if (!frame) frame = requestAnimationFrame(draw);
    };
    main.addEventListener('pointermove', move, { passive: true });
    main.addEventListener('pointerleave', clear, { passive: true });
    window.addEventListener('scroll', clear, { passive: true });
    document.addEventListener('visibilitychange', clear);
    mouse.addEventListener('change', clear);
    reduced.addEventListener('change', clear);
    const unload = event => {
      if (event.target.contains(anchor)) teardown();
    };
    document.addEventListener('shopify:section:unload', unload);
    teardown = () => {
      clear();
      layer.remove();
      main.removeEventListener('pointermove', move);
      main.removeEventListener('pointerleave', clear);
      window.removeEventListener('scroll', clear);
      document.removeEventListener('visibilitychange', clear);
      mouse.removeEventListener('change', clear);
      reduced.removeEventListener('change', clear);
      document.removeEventListener('shopify:section:unload', unload);
      teardown = null;
    };
  }
  window[key] = { init };
  document.addEventListener('shopify:section:load', init);
  init();
})();
